import axios from './axios.service';

export const getCourseRegister = (courseId) => {
  return axios.get(`/course/get_course_register/${courseId}`).then((res) => res.register);
};
